import { buildMessengerHref } from '../../core/messengerLinks';
import { MmAuditorMessenger } from '../../types/domain';
import { MM_MESSENGER_TITLES, MM_MESSENGERS } from '../../types/enums';

export interface MmMessengerSendAction {
	key: string;
	type: string;
	title: string;
	href: string;
	needsCopy: boolean;
}

export function extractPhoneDigits(phone: string | null | undefined): string {
	if (phone === null || phone === undefined) {
		return '';
	}

	return String(phone).replace(/\D/g, '');
}

export function buildMessengerSendAction(
	code: string,
	item: MmAuditorMessenger,
	phone: string | null | undefined,
	greeting: string,
	index: number,
): MmMessengerSendAction | null {
	const title = MM_MESSENGER_TITLES[code] ? MM_MESSENGER_TITLES[code] : code;
	const username = item.username !== undefined ? item.username : null;
	const phoneArg = phone !== undefined ? phone : null;
	const href = buildMessengerHref(code, username, phoneArg, greeting);
	let needsCopy = true;

	if (href === '') {
		return null;
	}

	if (code === 'WHATSAPP') {
		needsCopy = false;
	}

	return {
		key: code + '#' + String(index),
		type: code,
		title: title,
		href: href,
		needsCopy: needsCopy,
	};
}

export function buildMessengerSendActions(
	messengers: MmAuditorMessenger[] | null | undefined,
	phone: string | null | undefined,
	greeting: string,
): MmMessengerSendAction[] {
	const source = messengers !== null && messengers !== undefined ? messengers : [];
	const order = MM_MESSENGERS as string[];
	const result: MmMessengerSendAction[] = [];

	for (let i = 0; i < order.length; i += 1) {
		const code = order[i];

		for (let j = 0; j < source.length; j += 1) {
			const item = source[j];

			if (!item || String(item.type).toUpperCase() !== code) {
				continue;
			}

			const action = buildMessengerSendAction(code, item, phone, greeting, j);

			if (action !== null) {
				result.push(action);
			}
		}
	}

	for (let j = 0; j < source.length; j += 1) {
		const item = source[j];

		if (!item) {
			continue;
		}

		const code = String(item.type).toUpperCase();

		if (order.indexOf(code) !== -1) {
			continue;
		}

		const action = buildMessengerSendAction(code, item, phone, greeting, j);

		if (action !== null) {
			result.push(action);
		}
	}

	return result;
}
